/*global VeloxViewController, VeloxWebView*/
var legalsController = new VeloxViewController({
    directory: "views/login",
    name: "legals",
    route: "legals",
    openInPopup: true,
    popup: {
        size: "medium"
    },
});

module.exports = legalsController ;